import { SITE } from "@/data/site";
import { AGGREGATE, REVIEWS } from "@/data/reviews";

const REVIEWED_BUSINESS = "Wedding Video Essex";

export const localBusinessLd = (town) => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE.url}/#business`,
  name: REVIEWED_BUSINESS,
  description: `Award-winning wedding videographers and photographers covering Essex. ${AGGREGATE.count} verified 5-star reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides. 1000+ couples filmed. 8x award winners including the Hitched Wedding Awards five years in a row and Essex Wedding Awards Videographer of the Year.`,
  url: SITE.bookingUrl,
  image:
    "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg",
  priceRange: "£1,495–£3,500",
  serviceType: "Wedding videography & photography",
  areaServed: town
    ? [
        {
          "@type": "City",
          name: town.name,
          containedInPlace: { "@type": "AdministrativeArea", name: "Essex" },
        },
      ]
    : [
        { "@type": "AdministrativeArea", name: "Essex" },
        { "@type": "City", name: "London" },
        { "@type": "AdministrativeArea", name: "Kent" },
        { "@type": "AdministrativeArea", name: "Suffolk" },
      ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Unit 6 Hodgson Court, Hodgson Way",
    addressLocality: "Wickford",
    addressRegion: "Essex",
    postalCode: "SS11 8XR",
    addressCountry: "GB",
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer service",
      name: "Alex Moore",
      telephone: "+44-1277-280512",
      email: "alex@weddingvideo.co.uk",
      url: "https://www.weddingvideo.co.uk/contact",
      areaServed: ["GB-ESS", "GB-ENG", "GB-LND", "GB-KEN", "GB-SFK"],
      availableLanguage: ["English"],
    },
  ],
  sameAs: [
    "https://www.instagram.com/weddingvideoessex/",
    "https://www.facebook.com/essexweddingvideo",
    "https://x.com/WedVidEssex",
    SITE.hitchedUrl,
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: AGGREGATE.rating.toFixed(1),
    reviewCount: AGGREGATE.count,
    bestRating: "5",
    worstRating: "1",
  },
  review: REVIEWS.slice(0, 8).map((r) => ({
    "@type": "Review",
    reviewRating: {
      "@type": "Rating",
      ratingValue: r.rating,
      bestRating: 5,
    },
    author: { "@type": "Person", name: r.name },
    reviewBody: r.text,
    name: r.title,
    url: r.url,
    publisher: { "@type": "Organization", name: "Hitched.co.uk" },
  })),
});

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE.url}/#website`,
  url: SITE.url,
  name: SITE.name,
  description:
    "Independent review hub for Wedding Video Essex, the most-reviewed wedding videographer and photographer in Essex.",
});

export const faqLd = (faqs, count) => {
  const sub = (t) =>
    count != null ? (t || "").replaceAll("{{count}}", String(count)) : t;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: sub(f.q),
      acceptedAnswer: { "@type": "Answer", text: sub(f.a) },
    })),
  };
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});
